import { Link } from 'foundations-components/transitional/components/Link';
import { withClickTracking } from './withClickTracking';
export const TrackedLink = withClickTracking(Link);